"use strict";

function _typeof(obj) {"@babel/helpers - typeof";return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, _typeof(obj);}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Label = exports.Divider = exports.ClearIcon = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Icon = require("../Icon");
var _IconButton = _interopRequireWildcard(require("../IconButton"));
var _sizes = _interopRequireDefault(require("./sizes"));
function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
function _getRequireWildcardCache(nodeInterop) {if (typeof WeakMap !== "function") return null;var cacheBabelInterop = new WeakMap();var cacheNodeInterop = new WeakMap();return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {return nodeInterop ? cacheNodeInterop : cacheBabelInterop;})(nodeInterop);}
function _interopRequireWildcard(obj, nodeInterop) {if (!nodeInterop && obj && obj.__esModule) {return obj;}if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {return { default: obj };}var cache = _getRequireWildcardCache(nodeInterop);if (cache && cache.has(obj)) {return cache.get(obj);}var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {Object.defineProperty(newObj, key, desc);} else {newObj[key] = obj[key];}}}newObj.default = obj;if (cache) {cache.set(obj, newObj);}return newObj;}
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var Label = _styledComponents.default.p.withConfig({
  displayName: "fluffy--Label",
  componentId: "fluffy--u2xy7o"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-weight: 700;\n    line-height: 16px;\n    color: black;\n    flex: none;\n    order: 0;\n    flex-grow: 0;\n"], ["\n    font-weight: 700;\n    line-height: 16px;\n    color: black;\n    flex: none;\n    order: 0;\n    flex-grow: 0;\n"])));
exports.Label = Label;
var Divider = _styledComponents.default.div.withConfig({
  displayName: "fluffy--Divider",
  componentId: "fluffy--1xbmuiw"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 1px;\n    height: 100%;\n    background-color: black;\n"], ["\n    width: 1px;\n    height: 100%;\n    background-color: black;\n"])));
exports.Divider = Divider;
var ClearIcon = (0, _styledComponents.default)(_IconButton.default).attrs(function () {
  return {
    icon: _Icon.Icons.XMark,
    size: _IconButton.IconButtonSizes.Tiny,
    variant: _IconButton.IconButtonVariants.Outline,
    theme: {
      colors: {
        brand: 'black'
      }
    }
  };
}).withConfig({
  displayName: "fluffy--ClearIcon",
  componentId: "fluffy--8f0elm"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border-radius: 50%;\n\n    &:hover {\n        background-color: lightcyan;\n    }\n"], ["\n    border-radius: 50%;\n\n    &:hover {\n        background-color: lightcyan;\n    }\n"])));
exports.ClearIcon = ClearIcon;
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "fluffy--Wrapper",
  componentId: "fluffy--n8s2nb"
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    box-sizing: border-box;\n    display: inline-flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 4px 16px;\n    position: relative;\n    border: 1px solid black;\n    background-color: #ffffff;\n\n    ", ";\n\n    ", " {\n        ", ";\n    }\n\n    ", " {\n        ", ";\n    }\n\n    ", " {\n        ", ";\n    }\n\n    ", "\n"], ["\n    box-sizing: border-box;\n    display: inline-flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 4px 16px;\n    position: relative;\n    border: 1px solid black;\n    background-color: #ffffff;\n\n    ", ";\n\n    ", " {\n        ", ";\n    }\n\n    ", " {\n        ", ";\n    }\n\n    ", " {\n        ", ";\n    }\n\n    ", "\n"])), function (_a) {
  var $size = _a.$size;
  return _sizes.default[$size || 'normal'].wrapper;
}, Label, function (_a) {
  var $size = _a.$size;
  return _sizes.default[$size || 'normal'].label;
}, Divider, function (_a) {
  var $size = _a.$size;
  return _sizes.default[$size || 'normal'].divider;
}, ClearIcon, function (_a) {
  var $size = _a.$size;
  return _sizes.default[$size || 'normal'].icon;
}, function (_a) {
  var $disabled = _a.$disabled;
  return $disabled && (0, _styledComponents.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        opacity: 0.6;\n    "], ["\n        opacity: 0.6;\n    "])));
});
exports.Wrapper = Wrapper;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;